"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Acl;
(function (Acl) {
    let VariableType;
    (function (VariableType) {
        VariableType["enum"] = "enum";
        VariableType["entity"] = "entity";
        VariableType["column"] = "column";
    })(VariableType = Acl.VariableType || (Acl.VariableType = {}));
    let Operation;
    (function (Operation) {
        Operation["read"] = "read";
        Operation["create"] = "create";
        Operation["update"] = "update";
        Operation["delete"] = "delete";
    })(Operation = Acl.Operation || (Acl.Operation = {}));
    let SystemPermissionsLevel;
    (function (SystemPermissionsLevel) {
        SystemPermissionsLevel["none"] = "none";
        SystemPermissionsLevel["any"] = "any";
        SystemPermissionsLevel["some"] = "some";
    })(SystemPermissionsLevel = Acl.SystemPermissionsLevel || (Acl.SystemPermissionsLevel = {}));
})(Acl || (Acl = {}));
exports.default = Acl;
//# sourceMappingURL=acl.js.map